<template>
  <div :key="item.id">
    <div
      @click.stop="chooseMuban(index, false)"
      v-if="item.label == 'div'"
      :style="item.style"
    >
      <zuhesub-template
        class="hoverClass"
        :class="item.isChoose ? 'active' : ''"
        v-if="item.template"
        :item="item.template"
      ></zuhesub-template>
      <div
        class="hoverClass"
        :class="item.isChoose ? 'active' : ''"
        v-else
        :style="item.style"
        style="height: 21px"
      >
        {{ item.title }}
      </div>
    </div>
    <!-- 栅格 -->
    <el-row class="rowhoverClass" v-if="item.label == 'row'" :style="item.style">
      <span @click.stop="chooseMuban(index, false)">
        <el-col
          :style="Item.style"
          :span="Item.col"
          v-for="(Item, _index) in item.htmlStyleList"
          :key="Item.id"
        >
          <div
            @click.stop="chooseSubMuban(index, _index)"
            style="width: 100%"
            class="hoverClass"
            :class="Item.isChoose ? 'active' : ''"
          >
            <zuhesub-template
              v-if="Item.template"
              :item="Item.template"
            ></zuhesub-template>
            <div v-else style="height: 21px">
              {{ Item.title }}
            </div>
          </div>
        </el-col>
      </span>
    </el-row>
  </div>
</template>
<script>
import zuhesubTemplate from "./zuhesubTemplate";
export default {
  components: { zuhesubTemplate },
  props: { item: Object, index: Number, noClick: Boolean },
  data() {
    return {
      videoUrl:
        "http://1251150518.vod2.myqcloud.com/8d224e9cvodgzp1251150518/a775f1ae3701925920751120030/4RPCJ58Vki4A.mp4",
      defaultPic:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
  watch: {
    item: {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    chooseMuban(index, bol) {
      if (this.noClick) {
        return;
      }
      this.$emit("chooseMuban", index, bol);
    },
    chooseSubMuban(index, _index) {
      if (this.noClick) {
        return;
      }
      this.$emit("choosesubmuban", index, _index);
    },
  },
};
</script>
<style scoped>
.el-image {
  width: 100%;
}
.active {
  border: 1px dashed rgb(121, 117, 117) !important;
}
.hoverClass:hover {
  border: 1px dashed rgb(121, 117, 117);
}
.prefixHoverClass:hover {
  border: 1px dashed rgb(23, 85, 218);
}
.rowhoverClass:hover {
  border: 1px dashed rgb(38, 212, 212);
}
.imageClass {
  display: block;
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;
}
.flexList {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/zuHeTemplate.vue